import { NullFunction } from '@deqo/foundation';
import { EventSourceBase } from '@deqo/podopolis';
import { uuid } from '../../CodesThatsGottaGoSomewhereElse';
import { Hangout } from './Hangout';
import { HangoutClient, HangoutClientStore } from './HangoutClient';
import { HangoutEvents } from './HangoutEvents';
import { HangoutLocationStore } from './HangoutLocation';
import { HangoutPodSession } from './HangoutPodSession';
import { HangoutTopic } from './HangoutTopic';
import { HangoutUserStore } from './HangoutUser';

export class NullHangout extends EventSourceBase<HangoutEvents> implements Hangout {

    public readonly self: HangoutClient = new HangoutClient(uuid());

    public readonly clients = new HangoutClientStore();

    public readonly locations = new HangoutLocationStore();

    public readonly users = new HangoutUserStore();

    public readonly ready: boolean = true;

    public getPod(): HangoutPodSession {
        return null;
    }

    public waitForReady(): Promise<void> {
        return Promise.resolve();
    }

    public subscribeTo(topic: string): HangoutTopic {
        return new HangoutTopic(topic, this, NullFunction);
    }

    public sendRelay(_to: string, _type: string, _data: any): void {
    }

    public updateMyLocation(): void {
    }

}
